import SimpleCaseSolution from "./SimpleCaseSolution.vue";
export default SimpleCaseSolution;
